import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Dealer Management System integration configuration.
 */
export const schema = z
  .object({
    service: z.string().describe('DMS service provider name (e.g., "CDK", "Reynolds", "DealerTrack")').optional(),
    props: z
      .record(z.unknown())
      .describe('Additional DMS-specific properties. Structure varies by provider.')
      .optional(),
  })
  .strict()
  .describe('Dealer Management System integration. Enables automatic data sync with dealership DMS.');

export type Dms = z.infer<typeof schema>;

export const definition = define({
  key: 'dms',
  schema,
  label: 'DMS',
  description: 'Dealer Management System integration. Enables automatic data sync with dealership DMS.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.DMS.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: {
    service: '',
    props: {},
  },
});
